import { getEnvironmentVariablesValue } from "@utility/environmentVariables";

export const SSO_SIGNUP_KEY = "@lum-s_s_o-signup@";
export const RECAPTCHA_SECRET = getEnvironmentVariablesValue("RECAPTCHA_SITE_KEY") || "6LcbPMgUAAAAAO8j2Z0MA2KzU2BanHcTCBfwxKG_";

// security headers constants
export const FORGOT_PASSWORD_SECURITY_KEY_ONE = getEnvironmentVariablesValue("FORGOT_PASSWORD_SECURITY_KEY_ONE") || "de513cc89289fa2be8a6ee6fdb6a9671b26a6db9"
export const FORGOT_PASSWORD_SECURITY_KEY_TWO = getEnvironmentVariablesValue("FORGOT_PASSWORD_SECURITY_KEY_TWO") || "fdb6a9671b26a6db9de513cc89289fa2be8a6ee6"
export const FORGOT_PASSWORD_SECURITY_KEY_THREE = getEnvironmentVariablesValue("FORGOT_PASSWORD_SECURITY_KEY_THREE") || "defa2be8a6ee6fdb6a9671b26a6db9513cc8928943"

export const SIGNUP_FLOW_SECURITY_KEY_ONE = getEnvironmentVariablesValue("SIGNUP_FLOW_SECURITY_KEY_ONE") || "dbciyegc238r3uge833yeic1c"
export const SIGNUP_FLOW_SECURITY_KEY_TWO = getEnvironmentVariablesValue("SIGNUP_FLOW_SECURITY_KEY_TWO") || "dbciyegc23ddduge833yeicc2"
export const SIGNUP_FLOW_SECURITY_KEY_THREE = getEnvironmentVariablesValue("SIGNUP_FLOW_SECURITY_KEY_THREE") || "dbciyegc23ddduge833yei3cc"
export const SIGNUP_FLOW_SECURITY_KEY_FOUR = getEnvironmentVariablesValue("SIGNUP_FLOW_SECURITY_KEY_FOUR") || "dbciyegc23ddduge833yeic4c"

export const SECURITY_HEADERS_LOGIN_TOKEN = getEnvironmentVariablesValue("SECURITY_HEADERS_LOGIN_TOKEN") || "ldo5g3ci89n89fa2be8a6ee6fdb6a9671b"
export const SECURITY_HEADERS_VERIFIED_TOKEN = getEnvironmentVariablesValue("SECURITY_HEADERS_VERIFIED_TOKEN") || "de513cc89289fa2be8a6ee6fdb6a9671b26a6db9"

export const SECURITY_HEADERS_VALIDATE_PASSWORD_TOKEN_ONE = getEnvironmentVariablesValue("SECURITY_HEADERS_VALIDATE_PASSWORD_TOKEN_ONE") || "f30c466b4e26587c6788060d436b0a29"
export const SECURITY_HEADERS_VALIDATE_PASSWORD_TOKEN_TWO = getEnvironmentVariablesValue("SECURITY_HEADERS_VALIDATE_PASSWORD_TOKEN_TWO") || "b72d1f93a4d6581e6f5b3d9801a6c74d"

export const X_SSO_TOKEN_HEADER = "x-sso-token"

// whitelabelling content
export const WHITE_LABELLING_CONTENT = {
    companyName: "Lumenore",
    logos: {
        light: "/assets/svg/lumenore-logo-light.svg",
        dark: "/assets/svg/lumenore-logo-dark.svg"
    },
    signupPageContent: {
        signupSlides: [
            {
                id: 1,
                title: "Bring all your data at one place",
                description: "Create a centralized data repository by connecting multiple sources, reducing data silos.",
                image: "/assets/png/signup-slide-3.png",
            },
            {
                id: 2,
                title: "Create AI-powered data visualizations and dashboards",
                description: "to analyze data without needing in-depth expertise.",
                image: "/assets/png/signup-slide-2.png",
            },
            {
                id: 3,
                title: "Unlock Insights. Connect, Visualize, and Analyze Your Data",
                description: "All for FREE.",
                image: "/assets/png/signup-slide-1.png",
            },
            {
                id: 4,
                title: "Upload Your Data and Start Asking questions",
                description: "Create a centralized data repository by connecting multiple sources, reducing data silos.",
                image: "/assets/png/signup-slide-4.png",
            },
        ],
        trustLogos: [
            {
                id: 1,
                icon: "/assets/png/trust-logo-1.png"
            },
            {
                id: 2,
                icon: "/assets/png/trust-logo-2.png"
            },
            {
                id: 3,
                icon: "/assets/png/trust-logo-4.png"
            },
            {
                id: 4,
                icon: "/assets/png/trust-logo-3.png"
            },
        ]
    },
    welcomePageContent: {
        title: "Powering Up Your Lumenore Trial🚀",
        bulletPoints: [
            {
                id: 1,
                title: "Hold tight! Your trial setup will be ready in just a few moments."
            },
            {
                id: 2,
                title: "Setting up your personalized workspace and data for exploration."
            },
            {
                id: 3,
                title: "If something goes off track, no worries! We’ll send you an email with your trial link."
            },
        ],
        featuresHeading: "Get full access to Lumenore during your trial. Here's what you can explore",
        featureCards: [
            {
                id: 1,
                icon: "/assets/png/connect-your-data-icon.png",
                title: "Connect Your Data",
                description: "Effortlessly connect to multiple data sources and start analyzing instantly."
            },
            {
                id: 2,
                icon: "/assets/png/define-your-schema-icon.png",
                title: "Define Your Schema",
                description: "Organize your data with custom Schemas for better structure and insights."
            },
            {
                id: 3,
                icon: "/assets/png/create-and-manage-datasets-icon.png",
                title: "Create and Manage Datasets",
                description: "Combine, clean, and transform data to create meaningful Datasets."
            },
            {
                id: 4,
                icon: "/assets/png/design-interactive-dashboards-icon.png",
                title: "Design Interactive Dashboards",
                description: "Build powerful, interactive dashboards to visualize your data and share insights."
            },
        ]
    },
    icons: {
        authConnectorIcon: {
            src: "icon-lumenoreai.svg",
        }
    },
    seo: {
        title: "Business Intelligence & Data Analytics | No Code | AI Platform | Lumenore",
        description: "Discover how our no-code, AI-powered analytics platform delivers real-time insights for smarter decisions.",
        pageDescription: "Business Intelligence & Data Analytics | No Code | AI Platform | Lumenore",
        keywords: [
            "AI analytics platform",
            "no-code BI",
            "Lumenore",
            "business intelligence",
            "real-time dashboards",
            "predictive analytics"
        ],
        author: "Lumenore",
        image: "/assets/png/lumenore-banner.png"
    },
    favicon: {
        src: "/assets/ico/lumenore-favicon.ico",
        sizes: "any"
    },
    pwa: {
        startUrl: "/",
        description: "Business Intelligence & Data Analytics | No Code | AI Platform | Lumenore",
        installDescription: "Enhance your Lumenore experience. Install the app on your device for seamless access to insights and advanced analytics anytime, anywhere.",
        installIcon: "/assets/png/lumenore-icon-192x192.png",
        shortcutLabel: "Add shortcut",
        appleTouchIcon: "/assets/png/lumenore-icon-192x192.png",
        icons: [
            {
                src: "/assets/png/lumenore-icon-192x192.png",
                type: "image/png",
                sizes: "192x192"
            },
            {
                src: "/assets/png/lumenore-icon-512x512.png",
                type: "image/png",
                sizes: "512x512"
            },
            {
                src: "/assets/png/lumenore-icon-192x192.png",
                type: "image/png",
                sizes: "192x192",
                purpose: "maskable"
            },
            {
                src: "/assets/png/lumenore-icon-512x512.png",
                type: "image/png",
                sizes: "512x512",
                purpose: "maskable"
            }
        ]
    },
    links: {
        errorSupportEmail: "connect@lumenore.com",
        helpUrl: "mailto:connect@lumenore.com",
        privacyUrl: "https://lumenore.com/privacy-statement/",
        termsUrl: "https://lumenore.com/termsofuse/",
        eulaUrl: "https://lumenore.com/lumenore-eula/"
    },
    footer: {
        copyright: "© ${year}, Lumenore. All rights reserved."
    }
};
